import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgSeaview = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="#E6E9EE"
    {...props}
  >
    <path d="M2 16.507c1.034-.343 1.87-1.023 2.507-2.041 1.415 1.79 5.094 2.2 6.9 0 2.017 1.483 5.19 2.507 6.988 0 .85.733 2.059 1.594 3.447 1.528M2 21.292c1.034-.343 1.87-1.023 2.507-2.041 1.415 1.79 5.094 2.2 6.9 0 2.017 1.483 5.19 2.507 6.988 0 .85.733 2.059 1.594 3.447 1.528" />
    <path
      clipRule="evenodd"
      d="M14.053 11.23a2.632 2.632 0 1 0 0-5.262 2.632 2.632 0 0 0 0 5.263Z"
    />
    <path d="m5.5 11.5 4.73-1.67M4 7l6.063.91M8 3.357l2.88 2.468M14 4.5V2m3 4 2.037-1.698M18 8.5h3m-1 4-2.686-1.791" />
  </svg>
);
const Memo = memo(SvgSeaview);
export default Memo;
